<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1></h1>
        <span class="pull-right icon-right orange" @click="sendImgs()">发送</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page" v-show="isHideImg">

        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSelectStudent = false">
              <span class="pull-left">学生：</span><i class="red must">*</i>
              <span class="pull-right margin-x-15 gray font-12">{{studentInfo.studentName ? studentInfo.studentName : ''}}</span>
            </a>
          </li>
        </ul>

      <div class="padding-15 bg-white">
        <textarea class="font-14" width="100%" rows="5" placeholder="输入您的点评，方便家长与您更好辅导孩子功课！" v-model="content"></textarea>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in imagesList">
              <div @click="index = index, isHideImg = false, imageSrc = image.baseAcessPath + image.thumb">
                <img :src="image.baseAcessPath + image.thumb" width="80" height="80"/>
              </div>
            </li>
            <li v-if="imagesList.length < 6">
              <div class="button-add" @click="capturePhoto();" v-if="isAndroid"></div>
              <div class="button-add" v-else>
                <form enctype="multipart/form-data" method="post" name="fileinfo">
                  <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" @change="updateImage()"/>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentFirstCharList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>

    <div class="main-page" v-if="!isHideImg">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="isHideImg = true">返回</a>
          <h1></h1>
          <span class="pull-right icon-right orange" @click="isHideDelImage = false">删除</span>
        </div>
        <div class="liner"></div>
      </div>

      <div class="bg-white" @click="isHideImg = true">
        <img class="mid-align" :src="imageSrc" width="100%" />
      </div>
    </div>

    <!-- 删除图片 -->
    <div class="maskdiv" v-if="!isHideDelImage" @click="isHideDelImage = true">
      <div class="bottom-block text-center" style="background:none">
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="delImage()"><span class="orange block font-16">删除</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="isHideDelImage = true"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { service, uploadMulUrl } from '../../service'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  computed: mapGetters({
    studentFirstCharList: 'getStudentsByFirstChar'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      login_data: JSON.parse(window.localStorage['login_data']),
      curcheId: 0,
      teacherId: 0,
      imagesList: [],
      studentInfo: {},
      content: '',
      insert_homework_para: service.setPara('insertHomeWork'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      isHideImg: true,
      isHideDelImage: true,
      index: 0,
      imageSrc: '',
      fileList: [],
      isAndroid: true,
      isHideSelectStudent: true
    }
  },
  components: {
    dialogStudents
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android
    this.setPara()

    this.getStuList()
  },
  methods: {
    ...mapMutations([
      'receiveStudents',
      'clearHomework',
      'clearStudentHomework'
    ]),
    setPara: function () {
      this.curcheId = this.cookie_login_data.curcheId
      this.teacherId = this.cookie_login_data.teacherId

      this.get_new_student_list_para.curcheId = this.curcheId
      this.get_new_student_list_para.sfzt = '在托'
      this.get_new_student_list_para.context = this
    },
    getStuList: function () {
      this.$store.dispatch('receiveStudents', this.get_new_student_list_para)
    },
    insertHomework: function () {
      this.insert_homework_para.imageList = this.imagesList
      this.insert_homework_para.curcheId = this.curcheId
      this.insert_homework_para.userId = this.teacherId
      this.insert_homework_para.userName = this.login_data[this.cookie_login_data.index].teacherName
      this.insert_homework_para.userImage = this.cookie_login_data.teacherIcon
      this.insert_homework_para.content = $.trim(this.content)

      this.insert_homework_para.studentId = this.studentInfo.studentId
      this.insert_homework_para.studentName = this.studentInfo.studentName
      if (this.studentInfo.imageAddress) {
        this.insert_homework_para.studentImageAddress = this.studentInfo.imageAddress
      } else {
        this.insert_homework_para.studentImageAddress = ''
      }

      let obj = {context: this, para: this.insert_homework_para, indicatorText: '发布中...', successFun: (response) => {
        this.$store.dispatch('clearHomework')
        this.$store.dispatch('clearStudentHomework')
        this.$router.replace('/homework/detail/' + response.data)
      }}
      service.request(obj)
    },
    updateImage: function () {
      let nl = 0
      let files = document.getElementById('pic').files
      if (files.length === 0) {
        return
      }

      if (files.length + this.imagesList.length > 6) {
        Toast('最多只能再上传' + (6 - this.imagesList.length) + '张图片')
        return
      }

      for (let i = 0; i < files.length; i++) {
        Indicator.open()
        lrz(files[i], {width: 1024})
        .then((rst) => {
          nl++
          let imageInfo = {}
          imageInfo.baseAcessPath = rst.base64
          imageInfo.image = ''
          imageInfo.thumb = ''
          imageInfo.fileName = rst.origin.name
          this.imagesList.push(imageInfo)
          let f = {}
          f.file = rst.file
          f.name = rst.origin.name
          this.fileList.push(f)
          if (nl == files.length) {
            Indicator.close()
          }
        })
      }
    },
    delImage: function (index) {
      // this.imagesList.splice(index, 1)
      this.imagesList.splice(this.index, 1)
      this.fileList.splice(this.index, 1)
      this.isHideDelImage = true
      this.isHideImg = true
    },
    sendImgs: function () {
      if (!this.studentInfo.studentName) {
        Toast('请选择学生')
        return
      }

      if ($.trim(this.content) == '') {
        Toast('请输入您的点评')
        return
      }

      if (this.fileList.length == 0) {
        this.imagesList = []
        this.insertHomework()
        return
      }

      let data = new window.FormData()
      for (let i = 0; i < this.fileList.length; i++) {
        data.append('pic', this.fileList[i].file, this.fileList[i].name)
      }

      let url = uploadMulUrl + this.cookie_login_data.phoneNum + '&needThumb=1'

      let that = this
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        that.imagesList = []
        for (var i = 0; i < response.data.length; i++) {
          var imageInfo = {}
          imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
          imageInfo.srcFilePath = response.data[i].image.srcFilePath
          imageInfo.thumbFilePath = response.data[i].image.thumbFilePath
          that.imagesList.push(imageInfo)
        }
        console.log('图片处理完成')
        that.insertHomework()
      }}
      service.request(obj)
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 50, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1000, targetHeight: 2000 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imageInfo = {}
      imageInfo.baseAcessPath = 'data:image/jpeg;base64,' + imageData
      imageInfo.image = ''
      imageInfo.thumb = ''
      this.imagesList.push(imageInfo)
      let f = {}
      f.file = this.dataURLtoBlob(imageInfo.baseAcessPath)
      f.name = this.fileList.length + '.png'
      this.fileList.push(f)
      Indicator.close()
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      this.studentInfo = student
      this.isHideSelectStudent = true
    }
  }
}
</script>
<style scoped>
  .group-link{padding:10px 50px 10px 15px}
</style>



// WEBPACK FOOTER //
// homeworkAdd.vue?5aafd1e8